// extracted by mini-css-extract-plugin
export default {"root":"root-AzDFK","main":"main-DrjoR","bold":"bold-XYe8A"};